export default __webpack_public_path__ + "img/PIC_NO_Brochures_de_de_48815_jpg.png";